<template>
    <div>
        <SidebarDropdown v-section:school_management>
            <template v-slot:button>
                <svg
                    :class="version.iconClasses"
                    class="h-6 w-6 text-gray-400 group-hover:text-gray-300 group-focus:text-gray-300 transition ease-in-out duration-150"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    stroke="none"
                >
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M2.1 7.6H6.5C6.83 7.6 7.1 7.33 7.1 7V2.6C7.1 2.27 6.83 2 6.5 2H2.1C1.77 2 1.5 2.27 1.5 2.6V7C1.5 7.33 1.77 7.6 2.1 7.6ZM5.9 6.4H2.7V3.2H5.9V6.4ZM2.1 21.9999H6.5C6.83 21.9999 7.1 21.7299 7.1 21.3999V16.9999C7.1 16.6699 6.83 16.3999 6.5 16.3999H2.1C1.77 16.3999 1.5 16.6699 1.5 16.9999V21.3999C1.5 21.7299 1.77 21.9999 2.1 21.9999ZM5.9 20.7999H2.7V17.5999H5.9V20.7999ZM6.5 14.8H2.1C1.77 14.8 1.5 14.53 1.5 14.2V9.79995C1.5 9.46995 1.77 9.19995 2.1 9.19995H6.5C6.83 9.19995 7.1 9.46995 7.1 9.79995V14.2C7.1 14.53 6.83 14.8 6.5 14.8ZM2.7 13.6H5.9V10.4H2.7V13.6ZM9.29995 6.5001H21.9C22.23 6.5001 22.5 6.2301 22.5 5.9001V3.7001C22.5 3.3701 22.23 3.1001 21.9 3.1001H9.29995C8.96995 3.1001 8.69995 3.3701 8.69995 3.7001V5.9001C8.69995 6.2301 8.96995 6.5001 9.29995 6.5001ZM21.2999 5.3001H9.89995V4.3001H21.2999V5.3001ZM21.9 13.7H9.29995C8.96995 13.7 8.69995 13.43 8.69995 13.1V10.9C8.69995 10.57 8.96995 10.3 9.29995 10.3H21.9C22.23 10.3 22.5 10.57 22.5 10.9V13.1C22.5 13.43 22.23 13.7 21.9 13.7ZM9.89995 12.5H21.2999V11.5H9.89995V12.5ZM9.29995 20.9H21.9C22.23 20.9 22.5 20.63 22.5 20.3V18.1C22.5 17.77 22.23 17.5 21.9 17.5H9.29995C8.96995 17.5 8.69995 17.77 8.69995 18.1V20.3C8.69995 20.63 8.96995 20.9 9.29995 20.9ZM21.2999 19.7H9.89995V18.7H21.2999V19.7Z"
                    />
                </svg>
                {{ $t('messages.attendance') }}
            </template>
            <template v-slot:items>
                <a
                    :href="route('rollcall.select')"
                    class="group w-full flex items-center pl-11 pr-2 py-2 text-sm leading-5 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                >
                    {{ $t('messages.rollcall') }}
                </a>
                <a
                    :href="route('groupAttendance.index')"
                    class="group w-full flex items-center pl-11 pr-2 py-2 text-sm leading-5 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                >
                    {{ $t('messages.group_review') }}
                </a>
                <a
                    :href="route('MonthlyAttendanceReport.index')"
                    class="group w-full flex items-center pl-11 pr-2 py-2 text-sm leading-5 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                >
                    {{ $t('messages.attendance_report') }}
                </a>
                <a
                    :href="route('absenteeism')"
                    class="group w-full flex items-center pl-11 pr-2 py-2 text-sm leading-5 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                >
                    {{ $t('messages.absenteeism') }}
                </a>
                <a
                    :href="route('attendance.check')"
                    class="group w-full flex items-center pl-11 pr-2 py-2 text-sm leading-5 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                >
                    {{ $t('messages.attendance_check') }}
                </a>
            </template>
        </SidebarDropdown>

        <SidebarDropdown>
            <template v-slot:button>
                <svg
                    :class="version.iconClasses"
                    class="h-6 w-6 text-gray-400 group-hover:text-gray-300 group-focus:text-gray-300 transition ease-in-out duration-150"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    stroke="none"
                >
                    <path
                        d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z"
                    ></path>
                </svg>
                {{ $t('messages.list_of_students') }}
            </template>
            <template v-slot:items>
                <a
                    :href="route('groups.index')"
                    class="group w-full flex items-center pl-11 pr-2 py-2 text-sm leading-5 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                >
                    {{ $t('messages.groups') }}
                </a>
                <a
                    :href="route('family-interviews.index')"
                    class="group w-full flex items-center pl-11 pr-2 py-2 text-sm leading-5 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                    v-section:school_management
                >
                    {{ $tc('messages.family_interviews', 2) }}
                </a>
                <a
                    :href="route('students.payments.group.select')"
                    class="group w-full flex items-center pl-11 pr-2 py-2 text-sm leading-5 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                    v-section:school_management
                >
                    {{ $tc('messages.payments', 2) }}
                </a>
            </template>
        </SidebarDropdown>

        <div v-section:school_management>
            <a
                :href="route('teachers.index')"
                :class="version.anchorClasses"
                class="mt-1 group flex items-center px-2 py-2 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
            >
                <svg
                    :class="version.iconClasses"
                    class="h-6 w-6 text-gray-400 group-hover:text-gray-300 group-focus:text-gray-300 transition ease-in-out duration-150"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    stroke="none"
                >
                    <path
                        d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z"
                    ></path>
                </svg>
                {{ $tc('messages.staff', 2) }}
            </a>
        </div>

        <div v-section:school_management>
            <a
                :href="route('bulletins.index')"
                :class="version.anchorClasses"
                class="mt-1 group flex items-center px-2 py-2 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
            >
                <IconFileRss
                    :class="version.iconClasses"
                    class="h-6 w-6 text-gray-400 group-hover:text-gray-300 group-focus:text-gray-300 transition ease-in-out duration-150"
                />
                {{ $tc('messages.bulletins', 2) }}
            </a>
        </div>

        <SidebarDropdown>
            <template v-slot:button>
                <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    :class="version.iconClasses"
                    class="h-6 w-6 text-gray-400 group-hover:text-gray-300 group-focus:text-gray-300 transition ease-in-out duration-150"
                    stroke="none"
                >
                    <path
                        d="M20 22H6C4.9 22 4 21.1 4 20V4C4 2.9 4.9 2 6 2H20V22Z"
                        fill="transparent"
                        stroke="#9ca3af"
                        stroke-width="1"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    ></path>
                    <path
                        d="M20 22H6C4.9 22 4 21.1 4 20C4 18.9 4.9 18 6 18H20V22Z"
                        fill="transparent"
                        stroke="#9ca3af"
                        stroke-width="1"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    ></path>
                    <path
                        d="M8 12H16"
                        stroke="#9ca3af"
                        stroke-width="1"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        fill="transparent"
                    ></path>
                    <path
                        d="M8 8H16"
                        stroke="#9ca3af"
                        stroke-width="1"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        fill="transparent"
                    ></path>
                </svg>
                {{ $tc('messages.programmings', 2) }}
            </template>
            <template v-slot:items>
                <a
                    :href="route('programmings.index')"
                    class="group w-full flex items-center pl-11 pr-2 py-2 text-sm leading-5 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                    v-section:activities_advanced
                >
                    {{ $t('messages.list') }}
                </a>
                <a
                    :href="route('programmings-calendar.index')"
                    class="group w-full flex items-center pl-11 pr-2 py-2 text-sm leading-5 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                    v-section:activities_advanced
                >
                    {{ $t('messages.calendar') }}
                </a>
                <a
                    :href="route('dimensions.index')"
                    class="group w-full flex items-center pl-11 pr-2 py-2 text-sm leading-5 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                >
                    {{ $t('messages.syllabus') }}
                </a>
            </template>
        </SidebarDropdown>

        <SidebarDropdown>
            <template v-slot:button>
                <svg
                    :class="version.iconClasses"
                    class="h-6 w-6 text-gray-400 group-hover:text-gray-300 group-focus:text-gray-300 transition ease-in-out duration-150"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    stroke="none"
                >
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M17.2199 2.8699L20.6299 6.2799C20.9299 6.5799 21.0999 6.9899 21.0999 7.4099V19.9999C21.0999 20.8799 20.3799 21.5999 19.4999 21.5999H4.4999C3.6199 21.5999 2.8999 20.8799 2.8999 19.9999V3.9999C2.8999 3.1199 3.6199 2.3999 4.4999 2.3999H16.0899C16.5099 2.3999 16.9199 2.5699 17.2199 2.8699ZM19.4999 20.3999C19.7199 20.3999 19.8999 20.2199 19.8999 19.9999V7.4099C19.8999 7.3099 19.8599 7.2099 19.7799 7.1299L16.3699 3.7199C16.2999 3.6399 16.1899 3.5999 16.0899 3.5999H4.4999C4.2799 3.5999 4.0999 3.7799 4.0999 3.9999V19.9999C4.0999 20.2199 4.2799 20.3999 4.4999 20.3999H19.4999ZM6.9999 8.0999H13.9999C14.3299 8.0999 14.5999 7.8299 14.5999 7.4999C14.5999 7.1699 14.3299 6.8999 13.9999 6.8999H6.9999C6.6699 6.8999 6.3999 7.1699 6.3999 7.4999C6.3999 7.8299 6.6699 8.0999 6.9999 8.0999ZM6.9999 11.3999H16.9999C17.3299 11.3999 17.5999 11.6699 17.5999 11.9999C17.5999 12.3299 17.3299 12.5999 16.9999 12.5999H6.9999C6.6699 12.5999 6.3999 12.3299 6.3999 11.9999C6.3999 11.6699 6.6699 11.3999 6.9999 11.3999ZM6.9999 15.8999H16.9999C17.3299 15.8999 17.5999 16.1699 17.5999 16.4999C17.5999 16.8299 17.3299 17.0999 16.9999 17.0999H6.9999C6.6699 17.0999 6.3999 16.8299 6.3999 16.4999C6.3999 16.1699 6.6699 15.8999 6.9999 15.8999Z"
                    />
                </svg>
                {{ $tc('messages.activities', 2) }}
            </template>
            <template v-slot:items>
                <a
                    :href="route('activities.create')"
                    class="group w-full flex items-center pl-11 pr-2 py-2 text-sm leading-5 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                >
                    {{ $t('messages.create') }}
                </a>
                <a
                    :href="route('activities.index')"
                    class="group w-full flex items-center pl-11 pr-2 py-2 text-sm leading-5 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                >
                    {{ $t('messages.list') }}
                </a>
                <a
                    :href="route('grades-table')"
                    class="group w-full flex items-center pl-11 pr-2 py-2 text-sm leading-5 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                >
                    {{ $t('messages.gradebook') }}
                </a>
                <a
                    :href="route('grades2csv')"
                    class="hidden group w-full flex items-center pl-11 pr-2 py-2 text-sm leading-5 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                >
                    {{ $t('messages.download_grades') }}
                </a>
                <a
                    :href="route('trimester-grades-select')"
                    class="group w-full flex items-center pl-11 pr-2 py-2 text-sm leading-5 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                >
                    {{ $tc('messages.grades', 2) }}
                </a>
                <a
                    :href="route('progress-evaluation.index')"
                    class="group w-full flex items-center pl-11 pr-2 py-2 text-sm leading-5 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                >
                    {{ $t('messages.progress_evaluation') }}
                </a>
                <a
                    :href="route('questions.index')"
                    class="group w-full flex items-center pl-11 pr-2 py-2 text-sm leading-5 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                >
                    {{ $tc('messages.questions', 2) }}
                </a>
            </template>
        </SidebarDropdown>

        <SidebarDropdown v-section:school_management>
            <template v-slot:button>
                <svg
                    :class="version.iconClasses"
                    class="h-6 w-6 text-gray-400 group-hover:text-gray-300 group-focus:text-gray-300 transition ease-in-out duration-150"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    stroke="none"
                >
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M18.615 3.13745H5.38496C4.11496 3.13745 3.08496 4.16745 3.08496 5.43745V18.6675C3.08496 19.9375 4.11496 20.9675 5.38496 20.9675H18.615C19.885 20.9675 20.915 19.9375 20.915 18.6675V5.43745C20.915 4.16745 19.885 3.13745 18.615 3.13745ZM19.715 18.6575C19.715 19.2675 19.225 19.7575 18.615 19.7575H5.38496C4.77496 19.7575 4.28496 19.2675 4.28496 18.6575V5.43745C4.28496 4.82745 4.77496 4.33745 5.38496 4.33745H18.615C19.225 4.33745 19.715 4.82745 19.715 5.43745V18.6575ZM12.5149 5.26758H11.4849C10.9749 5.26758 10.4749 5.48758 10.1249 5.87758C9.75494 6.28758 9.56494 6.85758 9.62494 7.41758L10.1349 12.4076C10.2349 13.3976 11.0349 14.1476 11.9949 14.1476C12.9549 14.1476 13.7449 13.3976 13.8549 12.4076L14.3649 7.41758C14.4249 6.84758 14.2449 6.28758 13.8649 5.87758C13.5249 5.49758 13.0249 5.26758 12.5149 5.26758ZM12.6649 12.2876C12.6249 12.6676 12.3449 12.9476 12.0049 12.9476C11.6649 12.9476 11.3849 12.6676 11.3449 12.2876L10.8349 7.29758C10.8149 7.06758 10.8849 6.84758 11.0249 6.67758C11.1549 6.53758 11.3149 6.45758 11.4949 6.45758H12.5249C12.7049 6.45758 12.8649 6.53758 12.9949 6.67758C13.1449 6.83758 13.2149 7.06758 13.1849 7.29758L12.6649 12.2876ZM10.205 16.9775C10.205 15.9875 11.015 15.1875 12.005 15.1875C12.995 15.1875 13.805 15.9875 13.805 16.9775C13.805 17.9675 12.995 18.7675 12.005 18.7675C11.015 18.7675 10.205 17.9675 10.205 16.9775ZM11.205 16.9775C11.205 17.4075 11.565 17.7675 12.005 17.7675C12.445 17.7675 12.805 17.4175 12.805 16.9775C12.805 16.5475 12.445 16.1875 12.005 16.1875C11.565 16.1875 11.205 16.5375 11.205 16.9775Z"
                    />
                </svg>
                {{ $tc('messages.fouls', 2) }}
            </template>
            <template v-slot:items>
                <a
                    :href="route('foul.group.select')"
                    class="group w-full flex items-center pl-11 pr-2 py-2 text-sm leading-5 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                >
                    {{ $t('messages.issue_foul') }}
                </a>
                <a
                    :href="route('foul.index')"
                    class="group w-full flex items-center pl-11 pr-2 py-2 text-sm leading-5 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                >
                    {{ $t('messages.list') }}
                </a>
                <a
                    :href="route('foul.group.index')"
                    class="group w-full flex items-center pl-11 pr-2 py-2 text-sm leading-5 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                >
                    {{ $t('messages.by_group') }}
                </a>
                <a
                    :href="route('intervention-records.index')"
                    class="group w-full flex items-center pl-11 pr-2 py-2 text-sm leading-5 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                >
                    {{ $t('messages.interventions') }}
                </a>
            </template>
        </SidebarDropdown>

        <SidebarDropdown v-if="false">
            <template v-slot:button>
                <svg
                    :class="version.iconClasses"
                    class="h-6 w-6 text-gray-400 group-hover:text-gray-300 group-focus:text-gray-300 transition ease-in-out duration-150"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    stroke="none"
                >
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M12 3.4a8.6 8.6 0 100 17.2 8.6 8.6 0 000-17.2zM7.451 6.162A7.368 7.368 0 0112 4.6c.322 0 .64.02.95.06l-.097.459a1.685 1.685 0 00.806 1.81l.398.23-.908 1.573a1.685 1.685 0 00-.41-.007l-2.172.228c-.34.036-.65.172-.9.38l-1.5-.866c.055-.32.018-.657-.12-.969L7.45 6.162zm-.976.915a7.385 7.385 0 00-1.62 2.988.421.421 0 00.31-.107L6.79 8.496a.421.421 0 00.103-.484l-.417-.935zM4.632 11.31a7.366 7.366 0 001.365 5.016c.114-.038.234-.064.357-.077l2.172-.229a1.69 1.69 0 01.41.007l.909-1.574-.399-.23a1.685 1.685 0 01-.805-1.81l.42-1.972-1.55-.895-1.5 1.35a1.685 1.685 0 01-1.38.414zm2.365 6.142a7.392 7.392 0 002.772 1.605l-.682-1.532a.421.421 0 00-.429-.248l-1.66.175zm4.246 1.909a7.366 7.366 0 005.034-1.322 1.685 1.685 0 01-.34-1.413l.42-1.972-1.55-.895-1.5 1.35a1.685 1.685 0 01-1.97.206l-.398-.23-.908 1.574c.083.107.154.224.21.352l.889 1.995c.051.115.089.234.113.355zm6-2.14a7.401 7.401 0 001.788-2.908l-1.036.109a.421.421 0 00-.368.331l-.454 2.136a.421.421 0 00.07.333zm2.088-4.21a7.368 7.368 0 00-1.46-5.515l-.35.316a1.685 1.685 0 01-1.97.207l-.4-.23-.908 1.574c.083.106.154.224.211.351l.888 1.995c.14.312.177.65.122.97l1.499.865c.25-.207.56-.344.9-.38l1.468-.153zm-2.311-6.45a7.392 7.392 0 00-2.834-1.634l-.097.453a.421.421 0 00.202.453l1.891 1.092c.158.09.357.07.492-.052l.346-.311zm-4.15 3.42c.182-.02.355.08.43.248l.888 1.995a.421.421 0 01-.103.484l-1.623 1.461a.421.421 0 01-.492.052l-1.892-1.092a.421.421 0 01-.201-.452l.454-2.137a.421.421 0 01.368-.33l2.172-.23z"
                    />
                </svg>
                {{ $t('messages.playground') }}
            </template>
            <template v-slot:items>
                <a
                    :href="route('playground.watch')"
                    class="group w-full flex items-center pl-11 pr-2 py-2 text-sm leading-5 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                >
                    {{ $t('messages.watch') }}
                </a>
            </template>
        </SidebarDropdown>

        <SidebarDropdown v-if="hasRole(['administrator', 'superadmin'])">
            <template v-slot:button>
                <svg
                    :class="version.iconClasses"
                    class="h-6 w-6 text-gray-400 group-hover:text-gray-300 group-focus:text-gray-300 transition ease-in-out duration-150"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    stroke="none"
                >
                    <path
                        d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                    ></path>
                </svg>
                ED
            </template>
            <template v-slot:items>
                <a
                    :href="route('admin.announcements.index')"
                    class="group w-full flex items-center pl-11 pr-2 py-2 text-sm leading-5 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                    v-section:school_management_team
                >
                    {{ $tc('messages.announcements', 2) }}
                </a>
                <a
                    href="/student-file-stats"
                    class="group w-full flex items-center pl-11 pr-2 py-2 text-sm leading-5 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                >
                    🧞 {{ $t('messages.genie') }}
                </a>
                <a
                    :href="route('admin.teacher-fouls.index')"
                    class="group w-full flex items-center pl-11 pr-2 py-2 text-sm leading-5 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                    v-section:school_management_team
                >
                    {{ $tc('messages.teacher_fouls', 2) }}
                </a>
                <a
                    :href="route('smiley-polls.index')"
                    class="group w-full flex items-center pl-11 pr-2 py-2 text-sm leading-5 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                    v-section:school_management_team
                >
                    {{ $tc('messages.polls', 2) }}
                </a>
                <a
                    :href="route('usage.stats.index')"
                    class="group w-full flex items-center pl-11 pr-2 py-2 text-sm leading-5 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                >
                    {{ $t('messages.usage_information') }}
                </a>
                <a
                    :href="route('sos')"
                    class="group w-full flex items-center pl-11 pr-2 py-2 text-sm leading-5 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                    v-section:school_management_team
                >
                    {{ $t('messages.sos') }}
                </a>
                <a
                    :href="route('conversations.batch.create')"
                    class="group w-full flex items-center pl-11 pr-2 py-2 text-sm leading-5 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                    v-section:messaging
                >
                    {{ $t('messages.group_message') }}
                </a>
                <a
                    :href="route('gamification.sets.index')"
                    class="group w-full flex items-center pl-11 pr-2 py-2 text-sm leading-5 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                    v-section:school_management_team
                >
                    {{ $tc('messages.gamification_sets', 2) }}
                </a>
                <a
                    :href="route('students_payments_general.index')"
                    class="group w-full flex items-center pl-11 pr-2 py-2 text-sm leading-5 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                    v-section:school_management
                >
                    {{ $tc('messages.payments', 2) }}
                </a>
                <a
                    href="/sociograms"
                    class="group w-full flex items-center pl-11 pr-2 py-2 text-sm leading-5 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                >
                    {{ $tc('messages.sociograms', 2) }}
                </a>
            </template>
        </SidebarDropdown>

        <div v-section:school_management>
            <a
                href="/attendance/canteen"
                :class="version.anchorClasses"
                class="mt-1 group flex items-center px-2 py-2 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
            >
                <svg
                    :class="version.iconClasses"
                    class="h-6 w-6 text-gray-400 group-hover:text-gray-300 group-focus:text-gray-300 transition ease-in-out duration-150"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    stroke="none"
                >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path
                        d="M4 11h16a1 1 0 0 1 1 1v.5c0 1.5 -2.517 5.573 -4 6.5v1a1 1 0 0 1 -1 1h-8a1 1 0 0 1 -1 -1v-1c-1.687 -1.054 -4 -5 -4 -6.5v-.5a1 1 0 0 1 1 -1z"
                    ></path>
                    <path d="M12 4a2.4 2.4 0 0 0 -1 2a2.4 2.4 0 0 0 1 2"></path>
                    <path d="M16 4a2.4 2.4 0 0 0 -1 2a2.4 2.4 0 0 0 1 2"></path>
                    <path d="M8 4a2.4 2.4 0 0 0 -1 2a2.4 2.4 0 0 0 1 2"></path>
                </svg>
                {{ $t('messages.canteen') }}
            </a>
        </div>

        <SidebarDropdown v-section:school_management>
            <template v-slot:button>
                <svg
                    :class="version.iconClasses"
                    class="h-6 w-6 text-gray-400 group-hover:text-gray-300 group-focus:text-gray-300 transition ease-in-out duration-150"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    stroke="none"
                >
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M4.60364 20.7959H19.5714C20.3507 20.7959 20.9845 20.1616 20.9845 19.3823V4.41406C20.9845 3.63428 20.3507 3 19.5714 3H4.60364C3.82336 3 3.18958 3.63428 3.18958 4.41406V19.3823C3.18958 20.1616 3.82336 20.7959 4.60364 20.7959ZM4.38879 4.41406C4.38879 4.2959 4.48547 4.2002 4.60364 4.2002H19.5714C19.6896 4.2002 19.7853 4.2959 19.7853 4.41406V19.3823C19.7853 19.5 19.6896 19.5957 19.5714 19.5957H4.60364C4.48547 19.5957 4.38879 19.5 4.38879 19.3823V4.41406ZM17.3736 11.373C16.4627 12.284 14.9857 12.3573 13.7399 11.6583C13.7284 11.671 13.7165 11.6835 13.7042 11.6958L8.01086 17.3887C7.81555 17.584 7.55969 17.6816 7.30383 17.6816C7.04797 17.6816 6.79211 17.584 6.5968 17.3887C6.20618 16.998 6.20618 16.3652 6.5968 15.9746L12.2902 10.2817L12.2934 10.2786C11.4934 9.00211 11.5361 7.43829 12.4875 6.48687C13.3078 5.6666 14.5664 5.52517 15.7048 5.99897L13.5391 8.16465C13.2942 8.40961 13.2942 8.80677 13.5391 9.05173L14.8087 10.3213C15.0537 10.5663 15.4508 10.5663 15.6958 10.3213L17.8615 8.15563C18.3353 9.29407 18.1868 10.5598 17.3736 11.373Z"
                    />
                </svg>
                {{ $tc('messages.incidents', 2) }}
            </template>
            <template v-slot:items>
                <a
                    :href="route('incidents.create')"
                    class="group w-full flex items-center pl-11 pr-2 py-2 text-sm leading-5 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                >
                    {{ $t('messages.create') }}
                </a>
                <a
                    :href="route('incidents.index')"
                    class="group w-full flex items-center pl-11 pr-2 py-2 text-sm leading-5 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                >
                    {{ $t('messages.list') }}
                </a>
            </template>
        </SidebarDropdown>

        <div>
            <a
                href="https://www.youtube.com/channel/UCk2HnA3NdJbw87dR4ISCuUg/playlists"
                target="_blank"
                rel="noopener noreferrer"
                :class="version.anchorClasses"
                class="mt-1 group flex items-center px-2 py-2 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
            >
                <svg
                    :class="version.iconClasses"
                    class="h-6 w-6 text-gray-400 group-hover:text-gray-300 group-focus:text-gray-300 transition ease-in-out duration-150"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    stroke="none"
                >
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12.07 5.76001C11.17 5.76001 10.41 6.04001 9.80999 6.60001C9.57999 6.81001 9.37999 7.06001 9.23999 7.32001C9.08999 7.58001 8.98999 7.87001 8.91999 8.18001C8.85999 8.48001 8.84999 8.78001 8.84999 9.15001C8.83999 9.45001 8.94999 9.74001 9.14999 9.94001C9.32999 10.13 9.57999 10.23 9.83999 10.23C10.4 10.23 10.84 9.79001 10.84 9.23001V8.85001C10.85 8.49001 10.95 8.23001 11.16 8.02001C11.36 7.82001 11.66 7.72001 12.06 7.72001C12.43 7.72001 12.69 7.81001 12.86 7.99001C13.05 8.18001 13.14 8.47001 13.14 8.86001C13.14 9.10001 13.12 9.30001 13.07 9.44001C13.02 9.60001 12.94 9.74001 12.85 9.87001C12.74 10.02 12.5 10.27 12.14 10.6C11.67 11.02 11.33 11.44 11.14 11.82C10.95 12.22 10.84 12.72 10.83 13.31L10.82 13.74C10.82 14.3 11.26 14.74 11.82 14.74C12.38 14.74 12.82 14.3 12.82 13.74C12.84 13.62 12.84 13.48 12.84 13.33C12.84 12.76 13.01 12.38 13.42 12.07C14.08 11.49 14.51 11 14.75 10.53C15.01 10.04 15.15 9.48001 15.15 8.87001C15.15 7.96001 14.87 7.20001 14.3 6.62001C13.73 6.05001 12.98 5.76001 12.07 5.76001ZM12.8401 17.24C12.8401 17.7923 12.3924 18.24 11.8401 18.24C11.2878 18.24 10.8401 17.7923 10.8401 17.24C10.8401 16.6877 11.2878 16.24 11.8401 16.24C12.3924 16.24 12.8401 16.6877 12.8401 17.24Z"
                    />
                </svg>
                {{ $tc('messages.tutorials', 2) }}
            </a>
        </div>

        <div>
            <a
                href="https://docs.google.com/forms/d/e/1FAIpQLScM2wr5EGFbu_OS8SdM3UrfLFEXNV_5yNRFonaX0B_ZSLMgCg/viewform"
                target="_blank"
                :class="version.anchorClasses"
                rel="noopener noreferrer"
                class="mt-1 group flex items-center px-2 py-2 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
            >
                <svg
                    :class="version.iconClasses"
                    class="h-6 w-6 text-gray-400 group-hover:text-gray-300 group-focus:text-gray-300 transition ease-in-out duration-150"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    stroke="none"
                >
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12.07 5.76001C11.17 5.76001 10.41 6.04001 9.80999 6.60001C9.57999 6.81001 9.37999 7.06001 9.23999 7.32001C9.08999 7.58001 8.98999 7.87001 8.91999 8.18001C8.85999 8.48001 8.84999 8.78001 8.84999 9.15001C8.83999 9.45001 8.94999 9.74001 9.14999 9.94001C9.32999 10.13 9.57999 10.23 9.83999 10.23C10.4 10.23 10.84 9.79001 10.84 9.23001V8.85001C10.85 8.49001 10.95 8.23001 11.16 8.02001C11.36 7.82001 11.66 7.72001 12.06 7.72001C12.43 7.72001 12.69 7.81001 12.86 7.99001C13.05 8.18001 13.14 8.47001 13.14 8.86001C13.14 9.10001 13.12 9.30001 13.07 9.44001C13.02 9.60001 12.94 9.74001 12.85 9.87001C12.74 10.02 12.5 10.27 12.14 10.6C11.67 11.02 11.33 11.44 11.14 11.82C10.95 12.22 10.84 12.72 10.83 13.31L10.82 13.74C10.82 14.3 11.26 14.74 11.82 14.74C12.38 14.74 12.82 14.3 12.82 13.74C12.84 13.62 12.84 13.48 12.84 13.33C12.84 12.76 13.01 12.38 13.42 12.07C14.08 11.49 14.51 11 14.75 10.53C15.01 10.04 15.15 9.48001 15.15 8.87001C15.15 7.96001 14.87 7.20001 14.3 6.62001C13.73 6.05001 12.98 5.76001 12.07 5.76001ZM12.8401 17.24C12.8401 17.7923 12.3924 18.24 11.8401 18.24C11.2878 18.24 10.8401 17.7923 10.8401 17.24C10.8401 16.6877 11.2878 16.24 11.8401 16.24C12.3924 16.24 12.8401 16.6877 12.8401 17.24Z"
                    />
                </svg>
                Feedback
            </a>
        </div>

        <div v-if="hasRole(['gamification_teacher', 'superadmin'])">
            <a
                :href="route('gamification.sets.index')"
                :class="version.anchorClasses"
                class="mt-1 group flex items-center px-2 py-2 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    :class="version.iconClasses"
                    class="text-gray-400 w-6 h-6"
                    viewBox="0 0 24 24"
                    stroke-width="2"
                    stroke="currentColor"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <circle cx="12" cy="5" r="2"></circle>
                    <path
                        d="M20 12.5v4.75a0.734 .734 0 0 1 -.055 .325a0.704 .704 0 0 1 -.348 .366l-5.462 2.58a4.998 4.998 0 0 1 -4.27 0l-5.462 -2.58a0.705 .705 0 0 1 -.401 -.691l-.002 -4.75"
                    ></path>
                    <path
                        d="M4.431 12.216l5.634 -2.332a5.065 5.065 0 0 1 3.87 0l5.634 2.332a0.692 .692 0 0 1 .028 1.269l-5.462 2.543a5.064 5.064 0 0 1 -4.27 0l-5.462 -2.543a0.691 .691 0 0 1 .028 -1.27z"
                    ></path>
                    <line x1="12" y1="7" x2="12" y2="13"></line>
                </svg>
                {{ $tc('messages.gamification_sets', 2) }}
            </a>
        </div>

        <div>
            <a
                href="/practice_dashboard"
                :class="version.anchorClasses"
                class="mt-1 group flex items-center px-2 py-2 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
            >
                <IconAbacus class="text-gray-400 w-6 h-6" :class="version.iconClasses" />
                {{ $t('messages.practice_dashboard') }}
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SidebarItemsForTeacher',
};
</script>
<script setup>
import SidebarDropdown from '@/components/SidebarDropdown.vue';
import { IconFileRss, IconAbacus } from '@tabler/icons-vue';

import { useAppSections } from '@/composables/useAppSections.js';

const props = defineProps({
    roles: {
        type: Array,
        required: false,
        default: () => [],
    },
    sections: {
        type: Array,
        required: false,
        default: () => [],
    },
});
const { vSection } = useAppSections(props.sections);

const version = {
    iconClasses: 'mr-3',
    anchorClasses: 'text-sm leading-5',
};

function hasRole(roles) {
    return props.roles.some((r) => roles.includes(r));
}
</script>
